import { convertToTransitKind } from 'common/utils/transitKinds'
import { VALID_MODE_IDS } from 'tickets/utils/constants'

export const convertToModeId = (subkind) => {
  const transitKind = convertToTransitKind(subkind)
  return VALID_MODE_IDS.includes(transitKind) ? transitKind : null
}
